import { IComboBoxOption } from "@fluentui/react";
import React, { useEffect } from "react";
import { SourceTypeEnum } from "../../../../api/models/source-type-enum";

interface DropDownAreaAndChartState {
  areasItems: IComboBoxOption[];
}

const useDropDownAreaAndChart = (input) => {
  const [state, setState] = React.useState<DropDownAreaAndChartState>({ areasItems: [] });
  const { areasItems } = state;
  const { isFileExcelExisting, isComponentInstance, isLocked } = input;

  const type = input.type ?? "area";

  useEffect(() => {
    if (input.sheetsAreaChartMap) {
      input.sheetsAreaChartMap.forEach((value: string[], key: string) => {
        if (input.sheet && input.sheet.code == key) {
          if (input.objectSource === SourceTypeEnum.EXCEL) {
            setState({ ...state, areasItems: [] });
          }
          const areaMap: IComboBoxOption[] = value?.map((area) => {
            if (area.includes("!")) {
              return createIComboBoxFromDistinctAreas(area);
            } else {
              return createIComboBoxFromAreas(area);
            }
          });
          setState({ ...state, areasItems: areaMap });
        }
      });
    }
  }, [input]);
  return { type, areasItems, isFileExcelExisting, isComponentInstance, isLocked };
};

function createIComboBoxFromAreas(areaValue: string): IComboBoxOption {
  return {
    key: areaValue,
    text: areaValue,
  };
}

function createIComboBoxFromDistinctAreas(areaValue: string): IComboBoxOption {
  let areaValueWithoutSource = areaValue.split("!")[1];
  return {
    key: areaValue,
    text: areaValueWithoutSource,
  };
}

export default useDropDownAreaAndChart;
